import { EventRejectionReason } from "../domain/rejectionReason.interface";
import { instanceBo } from "../utils/axios.create";
import { Event, EventRequest } from "../domain/event.interface";

const getEvents = async (eventId?: string): Promise<Event[]> => {
	const pathEventId = eventId ? `/${eventId}` : "";

	return instanceBo
		.get(`/events${pathEventId}`)
		.then((res) => {
			// API returns single object when searching by ID, array otherwise
			const data = res.data.body;
			return Array.isArray(data) ? data : [data];
		})
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const getEvent = async (eventId: string): Promise<Event> => {
	return instanceBo
		.get(`/events/${eventId}`)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const createEvent = async (event: EventRequest): Promise<Event> => {
	return instanceBo
		.post("/events", event)
		.then((res) => res.data.body.event)
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const updateEvent = async (
	eventId: string,
	event: Partial<EventRequest>,
): Promise<Event> => {
	return instanceBo
		.put(`/events/${eventId}`, event)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const deleteEvent = async (eventId: string): Promise<void> => {
	return instanceBo
		.delete(`/events/${eventId}`)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

/**
 * The reasons an event of this validation type may ADD — SIMS-8490 AC2.
 *
 * Fetched rather than held on the client: this is the catalogue a designer picks
 * FROM, and a second copy here would drift from the platform list the backend
 * actually validates against.
 */
const getAvailableRejectionReasons = async (
	validationType?: string,
): Promise<EventRejectionReason[]> => {
	return instanceBo
		.get("/events/rejection-reasons/available", {
			params: validationType ? { validationType } : undefined,
		})
		.then((res) => res.data?.body ?? [])
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

export const eventService = {
	getAvailableRejectionReasons,
	getEvents,
	getEvent,
	createEvent,
	updateEvent,
	deleteEvent,
};
